import React, {useEffect, useState} from "react";
import "./List_Clothing.scss";
import {Header_Clothing} from "../Component_Clothing/Header_Clothing/Header_Clothing";
import {useParams} from "react-router";
import {List_Card_Clothing} from "../Component_Clothing/List_Card_Clothing/List_Card_Clothing";
import {Header_Clothing_Back} from "../Component_Clothing/Header_Clothing_Back/Header_Clothing_Back";
import {Search_Closing} from "../Component_Clothing/Search_Clothing/Search_Closing";
import {clothing_products} from "../Services_Clothing";
import Rodal from "rodal";

let search = "";

function List_Clothing() {

    //hooks
    const {merchantId,catId} = useParams()

    //states
    const [data,set_data] = useState([])
    const [filterModal,set_filterModal] = useState(false)

    //life
    useEffect(()=>{
        window.scrollTo({left: 0, top: 0});
        getData()
    },[])

    const getData = async ()=>{
        const response = await clothing_products(merchantId,catId,1,search)
        console.log(response.data)
        set_data(response.data.results)
    }

    const paginate = async () =>{
        window.clothingPage = window.clothingPage+1;
        try{
            const response = await clothing_products(merchantId,catId,window.clothingPage,search)
            set_data((list)=>[...list,...response.data.results]);
        }catch (e) {
            console.log(e);
        }
    }

    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3
        if(!cond) {
            console.log("bottonnnnn");
            paginate()
        }
    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.clothingPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])


    const doSearch = (word)=>{
        if(word.length===0){
            search = "";
            getData()
        }
        if(word.length>1){
            search = word
            getData()
        }

    }

    const modal= ()=>{
        set_filterModal(!filterModal)
    }

    return(
        <div className="list-back">
            <Rodal
                customStyles={{ height: 'auto', bottom: 'auto', top: '50%', transform: 'translateY(-50%)',width:'300px'}}
                animation={"zoom"} visible={filterModal} onClose={()=>set_filterModal(false)}>

                <div className="filter-sec">
                    <div className="filter-row">
                        <div className="filter-label">
                            <span>گروهها</span>
                        </div>
                        <div className="filter-value">
                            <span>کیف و کفش</span>
                        </div>
                    </div>
                </div>

            </Rodal>
            <div className="list-clothing-container">
                <Header_Clothing/>
                <div className="list">
                    <Search_Closing modal={modal} search={doSearch} />
                    {data.map(item=>{
                        return(
                            <List_Card_Clothing merchantId={merchantId}  item={item}/>
                        )
                    })}
                </div>
            </div>
            </div>
    )

}
export {List_Clothing}
